import React from 'react'
import { AlertDialogTitle } from '@radix-ui/react-alert-dialog'
import { IconCalendarEvent } from '@tabler/icons-react'
import ModalContainer from '../ModalContainer'
import Typography from '../../atoms/Typography'
import { PrimaryButton } from '../../atoms/buttons/PrimaryButton'

const REDIRECT_URL = import.meta.env.VITE_APP_DEMO_BOOKING_URL

interface EnterpriseDemoDialogProps {
  isOpen: boolean
  onClose: () => void
}

const EnterpriseDemoDialog: React.FC<EnterpriseDemoDialogProps> = ({ isOpen, onClose }) => {
  const handleScheduleDemo = () => {
    window.open(REDIRECT_URL, '_blank', 'noopener,noreferrer')
    onClose()
  }

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center py-6 text-center">
        <div className="mb-4 rounded-full bg-light-green-100 p-3">
          <IconCalendarEvent className="h-6 w-6 text-light-green-500" />
        </div>

        <AlertDialogTitle className="font-inter text-2xl font-bold text-light-green-50">
          Let&apos;s discuss your requirements
        </AlertDialogTitle>

        <Typography variant="base" className="mt-3 max-w-sm text-gray-400">
          Schedule a call to explore how Enterprise can support your carbon project workflows.
        </Typography>

        <PrimaryButton onClick={handleScheduleDemo} className="mt-6 w-full" rightIcon={<IconCalendarEvent size={18} />}>
          Schedule a call with us
        </PrimaryButton>
      </div>
    </ModalContainer>
  )
}

export default EnterpriseDemoDialog
